"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Sidebar/CampaignsList/TeamBadge.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

/* The team line under a campaign row's status. Nothing without a name. */
const TeamBadge = ({ name }) => (name ? (
  _react2.default.createElement('div', { className: "broadcast-list--campaign--team-badge--wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 5}}
    , _react2.default.createElement('span', { className: "broadcast-list--campaign--team-badge", __self: this, __source: {fileName: _jsxFileName, lineNumber: 6}}
      ,  name 
    )
  )
) : null)

exports. default = TeamBadge
